<template>
    <Teleport to="body">
      <div v-if="applicant" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md m-4">
          <!-- Modal Header -->
          <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
            <h3 class="text-lg font-medium text-[#035a76] dark:text-white">Applicant Details</h3>
            <button @click="$emit('close')" class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
  
          <!-- Modal Body -->
          <div class="px-6 py-4 space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Name</label>
              <p class="mt-1 text-sm text-gray-900 dark:text-white">{{ applicant.name }}</p>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Position</label>
              <p class="mt-1 text-sm text-gray-900 dark:text-white">{{ applicant.position }}</p>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Status</label>
              <p class="mt-1 text-sm text-gray-900 dark:text-white">{{ applicant.status }}</p>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">CV</label>
              <!-- <a :href="applicant.cv" target="_blank" class="text-blue-600 hover:underline dark:text-blue-400">View CV</a> -->
              <a :href="backendURL + applicant.cv" target="_blank" class="text-blue-600 hover:underline dark:text-blue-400">View CV</a>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Reason for Status</label>
              <p class="mt-1 text-sm text-gray-900 dark:text-white">{{ applicant.comment || 'No comment provided' }}</p>
            </div>
          </div>
  
          <!-- Modal Footer -->
          <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex justify-end">
            <button
              @click="$emit('close')"
              class="px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-300 dark:hover:bg-gray-500"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </template>
  
  <script setup>
  const props = defineProps({
    applicant: Object
  });
  
  defineEmits(['close']);
    const backendURL = "http://localhost:8000/api/";

  </script>